import { AsyncPortal } from "@circle-react-uikit/AsyncPortal";
import { Loader } from "@circle-react-uikit/Loader";

import { STANDARD_LAYOUT_V2_COVER_IMAGE_CONTAINER as id } from "@/react/components/constants";

export interface CoverImageLoaderProps {
  isLoading?: boolean;
}

export const CoverImageLoader = ({
  isLoading = true,
}: CoverImageLoaderProps) => {
  if (!isLoading) return null;

  return (
    <AsyncPortal selectorQuery={`#${id}`}>
      <div className="bg-primary relative h-[30vh]">
        <div
          className="absolute top-0 m-auto flex size-full"
          data-testid="cover-image-loader"
        >
          <Loader center />
        </div>
      </div>
    </AsyncPortal>
  );
};
